import React, { Component } from 'react';
import { Provider } from 'react-redux';
import configureStore from '../store/configureStore';

import AdminTheme from '../theme';
import App from './App';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const store = configureStore();

const muiTheme = getMuiTheme(AdminTheme);

export default function Root() {
  return (
    <Provider store={store}>
      <MuiThemeProvider muiTheme={muiTheme}>
        <App />
      </MuiThemeProvider>
    </Provider>
  );
}



/** WEBPACK FOOTER **
 ** ./components/Root.js
 **/